import { request } from './common';

export function autoSetupProperties(file: File) {
  const formData = new FormData();
  formData.append('file', file);

  return request(`${window.configs.API_HOST}/api/properties/auto-setup`, {
    method: 'POST',
    body: formData,
    headers: {
      Accept: 'application/json',
    },
  });
}
